<div class="page-padding" style="padding: 24px;">
  <div style="margin-left: 39%;" *ngIf="equipmentDetails == null" [@enterAnimation]>
    <mat-spinner></mat-spinner>
  </div>
  <div class="panel" *ngIf="equipmentDetails != null">
    <div class="panel__header">
      <span class="panel__header__title">
        Equipment Details
      </span>
    </div>
    <div class="panel__content flex flex--align-center">
      <div class="overall-eval-container">
        <a class="menu_links" (click)="viewObservationImages(equipmentDetails)" *ngIf="equipmentDetails.EquipmentPhoto !== ''" onmouseover="" style="cursor: pointer;">
        <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo"     />
        </a>
        <div class="bold font-size--xl margin-r--24 {{getEvalClass(equipmentDetails.PercentWorn)}}"
          style="border-radius: 4px;color: white;">
          {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
        </div>
      </div>
      <div class="column-container flex-grow">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Customer
            </span>
            <span class="text-block__important">
              {{equipmentDetails.CustomerName}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <span class="text-block__important">
              {{equipmentDetails.JobsiteName}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Serial Number
            </span>
            <span class="text-block__important">
              {{equipmentDetails.SerialNumber}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Unit Number
            </span>
            <span class="text-block__important">
              {{equipmentDetails.UnitNumber}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Last Inspection Date
            </span>
            <span class="text-block__important">
              {{equipmentDetails.LastInspectionDate}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Next Inspection Date
            </span>
            <span class="text-block__important">
              {{ equipmentDetails.NextInspectionDate }}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Meter Reading (SMU)
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Smu}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Life to Date (LTD)
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Ltd}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Make
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Make}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Model
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Model}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Family
            </span>
            <span class="text-block__important">
              {{equipmentDetails.Family}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Setup Date
            </span>
            <span class="text-block__important">
              {{equipmentDetails.EquipmentSetupDate}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex columns" *ngIf="equipmentDetails != null">
    <div class="panel panel--tasks" style="flex-shrink: 0.1;width: 67%;    height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Tasks
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" style="height: 150px;">
       
        <a class="square-button" (click)="openImplementAction()" *ngIf="!isJobRoleDefault && EnablePreference.showImplementAction">
          <i class="material-icons square-button__icon">mode_edit</i>
          <span class="square-button__label">Asset Repairs</span>
        </a>

        <a class="square-button" *ngIf="isJobRoleDefault && EnablePreference.showImplementAction" style="color: lightgrey;" >
          <i class="material-icons square-button__icon">mode_edit</i>
          <span class="square-button__label">Asset Repairs</span>
        </a>

        <a class="square-button" (click)="openChangeJobsite()" *ngIf="!isJobRoleDefault && EnablePreference.showChangeJobsite">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>
        <a class="square-button"  *ngIf="isJobRoleDefault && EnablePreference.showChangeJobsite" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <!-- <a class="square-button" (click)="openUpdateMeter()"  *ngIf="!isJobRoleDefault && EnablePreference.showUpdateMeter">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">Update Meter</span>
        </a> -->

        <a class="square-button" *ngIf="isJobRoleDefault && EnablePreference.showUpdateMeter" style="color: lightgrey;">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">Update Meter</span>
        </a>

        <a class="square-button" (click)="openChangeMeterUnit()" *ngIf="!isJobRoleDefault && EnablePreference.showChangeMeterUnit">
          <i class="material-icons square-button__icon">swap_horiz</i>
          <span class="square-button__label">Change Meter Unit</span>
        </a>

        <a class="square-button"   *ngIf="isJobRoleDefault  && EnablePreference.showChangeMeterUnit" style="color: lightgrey;">
          <i class="material-icons square-button__icon">swap_horiz</i>
          <span class="square-button__label">Change Meter Unit</span>
        </a>
        
        <a class="square-button" target="_blank" href="/setup/implement/{{equipmentId}}" *ngIf="!isJobRoleDefault  && EnablePreference.showSetupImplemet">
          <i class="material-icons square-button__icon">build</i>
          <span class="square-button__label">Setup Implement</span>
        </a>
        <a class="square-button" *ngIf="isJobRoleDefault && EnablePreference.showSetupImplemet" style="color: lightgrey;">
          <i class="material-icons square-button__icon">build</i>
          <span class="square-button__label">Setup Implement</span>
        </a>

        <a class="square-button" target="_blank" (click)="OpenMovetoInventory()" style="width: max-content"  *ngIf="!isJobRoleDefault && EnablePreference.showMoveToInventory" >
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move to Inventory</span>
        </a>
        <a class="square-button" style="width: max-content;color: lightgrey;" *ngIf="isJobRoleDefault && EnablePreference.showMoveToInventory" >
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move to Inventory</span>
        </a>

        <a class="square-button" target="_blank" (click)="openAttachImplementModal()" style="width: max-content" *ngIf="!isJobRoleDefault && EnablePreference.showMoveFromInventory">
            <i class="material-icons square-button__icon">swap_vertical_circle</i>
            <span class="square-button__label">Move from Inventory</span>
          </a>

          <a class="square-button"  style=" width: max-content;color: lightgrey;" *ngIf="isJobRoleDefault && EnablePreference.showMoveFromInventory" >
            <i class="material-icons square-button__icon">swap_vertical_circle</i>
            <span class="square-button__label">Move from Inventory</span>
          </a>


        <a class="square-button" target="_blank" (click)="openImplementSortOrder()" *ngIf="EnablePreference.showImpSortOrder" >
          <i class="material-icons square-button__icon">swap_vert</i>
          <span class="square-button__label">Implement Sort Order</span>
        </a>

        <a class="square-button" target="_blank" href="/get-inspection/{{equipmentId}}"  *ngIf="!isJobRoleDefault && EnablePreference.showPerformInsp">
            <i class="material-icons square-button__icon">find_in_page</i>
            <span class="square-button__label">Perform Inspection</span>
          </a>

          <a class="square-button" *ngIf="isJobRoleDefault && EnablePreference.showPerformInsp" style="color: lightgrey;">
            <i class="material-icons square-button__icon">find_in_page</i>
            <span class="square-button__label">Perform Inspection</span>
          </a>
         
         

          
      </div>
    </div>


    <div class="panel panel--next-inspection" style="flex-shrink:0.1; margin-left: 0;     height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Next Inspection
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch">
        <div class="square-button" (click)="openInspectionPlannerDialog()">
          <i class="material-icons square-button__icon">event_note</i>
          <span class="smuReadings">Smu : {{equipmentDetails.NextSmu}}</span>
          <span class="square-button__label">{{ equipmentDetails.NextInspectionDate| date:'dd/MMM/yyyy' }}</span>
        </div>
      </div>
    </div>

    <div class="panel panel--inspections" style="margin-left:15px;width: 512px;     height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Inspection History
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" style="overflow-x: auto;     justify-content: safe;">

        <div class="square-button" *ngFor="let inspection of inspectionDetails;" [matMenuTriggerFor]="inspectionMenu"  (click)="openInspection(inspection)">
          <ng-container *ngFor="let item of inspection.InspectionsDetails | slice:0:3; let i=index"  >
            <div class=" CelltextWrap {{getEvalCode(item.Eval)}}" style="width: 90px;text-align: center;">
              <span class="square-button__label CelltextWrap  " style="color: white; padding: 1px;"
                title="{{item.ImplementName}} / SMU - {{item.SMU}}">{{item.ImplementName}}</span>
            </div>
          </ng-container>
          <div *ngIf="inspection.InspectionsDetails.length>=4">
            <span class="smuReadings">... and {{inspection.InspectionsDetails.length -3}} more</span>
          </div>
          <!-- <i class="square-button__icon {{getEvalCode(inspection.Eval)}}">{{inspection.Eval}}</i> -->
          <!-- <span class="smuReadings">Smu : {{inspection.SMU}}</span> -->
          <span class="square-button__label" style="margin-top: 10px;">{{inspection.InspectionDate}}</span>
            <mat-menu #inspectionMenu="matMenu">
                <button  *ngIf="!isJobRoleDefault" mat-menu-item (click)="openLink('inspection', inspection.InspectionDate, inspection)">{{'View / Edit'}}</button>
                <button mat-menu-item (click)="openLink('pdf', inspection.InspectionDate, inspection)">{{'PDF Report'}}</button>
            </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <mat-tab-group>
  <div *ngIf="equipmentDetails != null">
     <div style="margin-left: 39%;" *ngIf="loading">
          <mat-spinner> </mat-spinner>
      </div>
      <mat-tab label="IMPLEMENTS DETAILS"> 
    <div *ngIf="ImplementForEquipmentDetails != null" >

        <div style="margin-left: 39%;" *ngIf="loading_imp">
            <mat-spinner> </mat-spinner>
        </div>
    <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
      <div style="overflow-x: auto;" class="mat-elevation-z8">
        <div style="background-color: white; padding: 1%;     margin-right: -15%;    max-width: 100%;">
          <app-implement-details-header [Implemetdetails]="implement.ImplementSummary" [evaldetails]="ImplementForEquipmentDetails"></app-implement-details-header>
        </div>
        <ng-container *ngFor="let item2 of implement.SchematicAndObservationPoints">
          <app-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId" [(SMU)]="equipmentDetails.Smu" (updateObs)="loadImplementDetails()" [isCrack]="1" [(ImplementId)]="implement.ImplementSummary.Id">
          </app-observation-details>
        </ng-container>
      </div>
    </ng-container>
    </div>
      </mat-tab>

      <mat-tab label="IMPLEMENTS HISTORY"> 
          <div  *ngIf="historyDetails_ != null">
              <div class="panel__content no-padding">

                <div>
                  <table class="table table--striped table--full-width" >
              
                    <thead>
                        <tr>
                           
                            <!-- <th class="ColumnCell">No Of Cycles </th> -->
                            <th class="ColumnCell">Total CMU</th>
                            <th class="ColumnCell">Total BCM's</th>
                            <th class="ColumnCell">Total Tons</th>
                            <th class="ColumnCell">Total Cost</th>
                            <th class="ColumnCell">Cost/CMU</th>
                            <th class="ColumnCell">Cost/BCM</th>
                            <th class="ColumnCell">Cost/Ton</th>
                        </tr>
                    </thead>
                    <tbody style="font-size: smaller;">
                        <ng-container >
                            <tr>
                                <!-- <td class="ColumnCell" >{{totalcycle}}</td> -->
                                <td class="ColumnCell" >{{totalsmu | number: '2.'}}</td>
                                <td class="ColumnCell">{{totalbcm | number: '2.'}}</td>
                                <td class="ColumnCell">{{totaltons | number: '2.'}}</td>
                                <td class="ColumnCell">${{totalcost | number: '.2'}}</td>
                                <td class="ColumnCell">${{ToDecimalPoints(totalcost,totalsmu) | number: '.2'}}</td>
                                <td class="ColumnCell">${{ToDecimalPoints(totalcost,totalbcm)| number: '.2'}}</td>
                                <td class="ColumnCell">${{ToDecimalPoints(totalcost,totaltons)| number: '.2'}}</td>
                              </tr>
                        </ng-container>
                    </tbody>
                </table>
                </div>
                <table class="table table--striped table--full-width">
              
                    <thead>
                        <tr>
                            <th >Model</th>
                            <th >Unit #</th>
                            <th >Serial #</th>
                            <th >Implement #</th>
                            <th >Date</th>
                            <th >Action</th>
                            <th >SMU</th>
                            <th>CMU</th>
                            <th >BCM</th>
                            <th >Tons</th>
                            <th >Cost</th>
                            <th >Comment</th>
                            <!-- <th >Repairer</th>
                            <th >Location</th> -->
                        </tr>
                    </thead>
                    <tbody style="font-size: smaller;">
                        <ng-container *ngFor="let OP of historyDetails_">
                            <tr>
                                <td>{{OP.Model}}</td>
                                <td>{{OP.Unit}}</td>
                                <td>{{OP.Serial}}</td>
                                <td>{{OP.ImplementName}}</td>
                                <td style="white-space: nowrap;">{{OP.ActionDate | date : 'dd-MMM-yyyy'}}</td>
                                <td>{{OP.ActionName}}</td>
                                <td>{{OP.Hours | number: '2.'}}</td>
                                <td>{{OP.HoursDiff | number: '2.'}}</td>
                                <td>{{OP.BCM ==-1?0:OP.BCM | number: '2.'}}</td>
                                <td>{{OP.Tons==-1?0:OP.Tons | number: '2.'}}</td>
                                <td>${{OP.Cost  | number: '.2'}}</td>
                                <td>{{OP.comment}}</td>
                                <!-- <td>{{OP.Repairer}}</td>
                                <td>{{OP.Location}}</td> -->
                                </tr>
                        </ng-container>
                    </tbody>
                </table>
                
                
      
              </div>
              </div>
      </mat-tab>
  </div>
</mat-tab-group>

</div>

